import { render, staticRenderFns } from "./UiCreateVendor.vue?vue&type=template&id=4e776a61&lang=pug&"
import script from "./UiCreateVendor.vue?vue&type=script&lang=js&"
export * from "./UiCreateVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports